import { render, staticRenderFns } from "./Italia.vue?vue&type=template&id=a767b950&"
import script from "./Italia.vue?vue&type=script&lang=js&"
export * from "./Italia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports